import React from "react";
import { BsCurrencyPound } from "react-icons/bs";

const Input = ({
  lableName,
  inputType,
  currency,
  textarea,
  onChange,
  value,
  name,
  disabled,
}) => {
  return (
    <>
      {textarea ? (
        <div className="flex flex-col gap-1 col-span-2 max-sm:col-span-1">
          <label htmlFor={lableName}>{lableName}</label>
          <textarea
            className="w-full border min-h-12 px-3 py-3 rounded-[10px] outline-none"
            onChange={onChange}
            value={value}
            name={name}
            id=""
            rows={1}
            placeholder="Enter text"
          ></textarea>
        </div>
      ) : (
        <div className="flex flex-col gap-1">
          <label htmlFor={lableName}>{lableName}</label>
          <div
            className={`flex items-center h-12 border rounded-[10px] ${
              !currency ? "px-3" : "pr-3"
            } ${disabled ? "bg-gray-200" : ""}`}
          >
            {currency && (
              <p className="ml-2 mr-3 pr-2 border-r">
                <BsCurrencyPound className="text-xl" />
              </p>
            )}
            <input
              placeholder={
                inputType === "text"
                  ? "Enter text"
                  : inputType === "number"
                  ? "Enter number"
                  : "Enter text"
              }
              className="w-full border-none outline-none "
              type={inputType}
              onChange={onChange}
              value={value}
              name={name}
              disabled={disabled && disabled}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Input;
